import React, { useRef, useEffect, useState } from "react"

import styled from "styled-components"

import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { motion, useAnimation } from "framer-motion"
/****STYLES */

/******STYLES */

export default function Image({ image }) {
  return (
    <motion.div>
      <GatsbyImage
        alt=""
        loading="eager"
        className="grid-image"
        image={image}
        placeholder="blurred"
      ></GatsbyImage>
    </motion.div>
  )
}
